import * as React from "react";

import { IParameter, IAddProps } from "../types";
import Form from "./Form";

const emptyParameter = {
  isDeleted: false,
  name: "",
  type: "TextBox",
  orderRender: 0,
  mandatory: false,
  defaultProfiles: false,
  defaultItems: false,
  defaultAdd: false,
  helpMessage: "",
  validation: "",
  msgError: "Error",
  parameterGroup: null,
  addedItemsConditionForItemInProfile: true,
  addedItemsConditionForItemInParameter: null,
  parameterProfileVisibilityConditions: [],
  parameterAddConditions: [],
  parameterProfileAddConditions: [],
  parameterItemStopInheritanceConditions: [],
  parameterMandatoryConditions: [],
  parameterVisibilityConditions: [],
  parameterWarnings: [],
  parameterTypeConditions: [],
};

export default class Add extends React.Component<IAddProps> {
  onSubmit = async (values: IParameter) => {
    await this.props.add(values);
    this.props.close();
  };

  render() {
    return (
      <Form
        id="new"
        initialValues={emptyParameter}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Parameters/components/New.tsx